module.exports = __webpack_public_path__ + "static/media/sales-heart-icon.d4d3f2be.svg";